import type { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { BookOpen } from 'react-feather';

import styles from './Navtabs.scss';

export const NAVTAB_HEIGHT = 48;

const Navtabs: FC = () => {
  const tabProps = {
    className: styles.link,
    activeClassName: styles.linkActive,
  };

  return (
    <nav className={styles.nav}>
      <NavLink {...tabProps} to="/courses">
        <BookOpen />
        <span className={styles.title}>Courses</span>
      </NavLink>
    </nav>
  );
};

export default Navtabs;
